var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{ref:"realLink",staticStyle:{"display":"none"},attrs:{"href":_vm.link}},[_vm._v("이동")])])}
var staticRenderFns = []

export { render, staticRenderFns }